import React, { useEffect, useState } from 'react';
import PropdocsModal from '../../../components/modal/PropdocsModal';
import { Button } from 'react-bootstrap';

interface SigningTimeoutModalProps {
  show: boolean;
  onClose: () => void;
  onTimeOut: () => void;
}

const COUNTDOWN_SECONDS = 180; // 3 minutes
const INTERVAL_MILLISECONDS = 1000;

export const SigningTimeoutModal: React.FC<SigningTimeoutModalProps> = ({ show, onClose, onTimeOut }) => {
  const [secondsLeft, setSecondsLeft] = useState<number>(COUNTDOWN_SECONDS);

  useEffect(() => {
    if (!show) {
      // Reset countdown when modal is hidden
      setSecondsLeft(COUNTDOWN_SECONDS);
      return;
    }

    const interval = setInterval(() => {
      setSecondsLeft((seconds) => {
        if (seconds <= 1) {
          onTimeOut();
          return 0;
        }
        return seconds - 1;
      });
    }, INTERVAL_MILLISECONDS);

    return () => {
      clearInterval(interval);
    };
  }, [show, onTimeOut]);

  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <PropdocsModal
      show={show}
      setShow={onClose}
      size="sm"
      title={<span>Are you still signing?</span>}
      disableClose={true}
    >
      <div>
        <p style={{ marginBottom: '1rem' }}>
          For security purposes, we've detected that you have been inactive for 3 minutes.
        </p>
        <p style={{ marginBottom: '1.5rem' }}>
          To protect your signing session, you will be redirected away from this page in{' '}
          <strong style={{ color: secondsLeft <= 30 ? '#dc3545' : 'inherit' }}>{formatTime(secondsLeft)}</strong>
        </p>
        <p style={{ fontSize: '0.875rem', color: '#6c757d', marginBottom: 0 }}>
          Click "Stay on page" to continue signing.
        </p>
        <div style={{ marginTop: '1.5rem', display: 'flex', justifyContent: 'flex-end' }}>
          <Button variant="primary" onClick={onClose} style={{ minWidth: '120px' }}>
            Stay on page
          </Button>
        </div>
      </div>
    </PropdocsModal>
  );
};
